import { useQuery } from '@apollo/client';
import { RECENTLY_CLAIMED_COMPANIES } from '@/graphql/queries';
import { CompaniesRecentlyClaimedOrder } from '@/graphql/__generated__/graphql';

const ORDERS = {
  RANDOM: CompaniesRecentlyClaimedOrder.Random,
  ID_DESC: CompaniesRecentlyClaimedOrder.IdDesc,
};

type RecentlyClaimedCompaniesProps = {
  limit: number;
  offset?: number;
};

const useRecentlyClaimedCompanies = ({
  limit = 4,
  offset = 0,
}: RecentlyClaimedCompaniesProps) => {
  const variables = { limit, offset, order: ORDERS.RANDOM };
  const { error, ...rest } = useQuery(RECENTLY_CLAIMED_COMPANIES, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return {
    error,
    ...rest,
  };
};

export { useRecentlyClaimedCompanies, ORDERS };
